module.exports = __webpack_public_path__ + "img/sw-face-sm.28dc9b38.webp";